export const AMERICA_TORONTO = 'America/Toronto'; // EST
export const UTC = 'utc';

export const DEFAULT_TIMEZONE = AMERICA_TORONTO;
